<script setup lang="ts">
import DatePicker from "@/core/components/date-picker/DatePicker.vue";
import TimePicker from "@/core/components/date-picker/TimePicker.vue";
import {Trash2} from "@lucide/vue";
import {Textarea} from "@/core/components/ui/textarea";
import {SupportProgramIndexResource} from "@/core/http/resources/SupportProgramResource";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/core/components/ui/select";
import {
    PartialAppointmentItem
} from "@/appointment/components/consumer-appointment-timeline/start-journey/AppointmentsCreationStep.vue";
import {AgendaOperator} from "@/agenda/lib/operators";
import {getLocalTimeZone, now} from "@internationalized/date";
import SupportProgramBookerSelect
    from "@/appointment/components/consumer-appointment-timeline/SupportProgramBookerSelect.vue";
import {watch} from "vue";
import {ProgramBookable} from "@/program/interfaces/ProgramBookable";

const {availableSupportPrograms} = defineProps<{
    availableSupportPrograms: SupportProgramIndexResource[];
    availableOperators: AgendaOperator[]
}>();

const modelValue = defineModel<PartialAppointmentItem>({
    required: true
});

watch(() => modelValue.value.bookable, () => {
    if (!!modelValue.value.bookable) {
        const supportProgram = availableSupportPrograms.find(program =>
            !!program.bookers?.find(booker => booker.id === (modelValue.value.bookable as ProgramBookable).id)
        );

        modelValue.value.supportProgram = supportProgram || null;
    }
});

defineEmits<{
    (e: 'remove', item: PartialAppointmentItem): void;
}>();
</script>

<template>
  <div class="bg-white border border-gray-200 rounded-lg p-4">
    <div class="flex text-sm gap-2 items-center flex-wrap">
      <SupportProgramBookerSelect
        v-model:model-value="modelValue.bookable"
        :support-programs="availableSupportPrograms"
        input-class="min-w-[100px] flex-1"
      />
      <span>le</span>
      <DatePicker
        v-model:model-value="modelValue.date"
        :min-value="now(getLocalTimeZone())"
        trigger-class="w-auto px-3"
        date-style="medium"
      />
      <span>à</span>
      <div class="w-auto">
        <TimePicker v-model="modelValue.startTime" class="w-auto pl-3 pr-2" step="300" />
      </div>
      <span>avec</span>
      <div class="flex-1 max-w-[120px]">
        <Select v-model:model-value="modelValue.operator_access_point_id">
          <SelectTrigger class="w-full">
            <SelectValue placeholder="Opérateur" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem
              v-for="operator in (availableOperators ?? [])"
              :key="operator.accessId"
              :value="String(operator.accessId)"
            >
              {{ operator.name }}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
    <div class="mt-2 flex gap-2">
      <Textarea
        v-model:model-value="modelValue.memo"
        class="mt-1 min-h-0 px-2"
        placeholder="Ajouter des notes pour le rendez-vous"
      />
      <button class="self-end" @click="$emit('remove', modelValue)">
        <Trash2 class="text-red-500 w-5 h-5" />
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>
